var exports = {
  "R": "xaee3c4fa--e83582--wrapper",
  "i": "xaee3c4fa--e83582--_clickable",
};

module.exports = exports;
